
// 从浏览器中获取社区名
export const getCommunityNameFromClient = () => {
  return import.meta.env.VITE_MOCK_COMMUNITY_NAME ?? window.location.hostname.split('.').reverse()[2] ?? '';
};
